/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
export type CostChannel = 'DEFAULT_COST_CHANNEL' | 'DELIVERY_COST_CHANNEL' | 'PICKUP_COST_CHANNEL';

export type PersonalizedUpsellsQueryVariables = Exact<{
  restaurantId: string;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type PersonalizedUpsellsQuery = {
  readonly personalizedUpsells:
    | { readonly __typename: 'MenuNotFound'; readonly errorMessage: string }
    | {
        readonly __typename: 'PersonalizedUpsell';
        readonly customerId: string | null;
        readonly restaurantId: string;
        readonly products: ReadonlyArray<{
          readonly __typename: 'UpsellCategoryProduct';
          readonly id: string;
          readonly name: string;
          readonly cost: number;
          readonly channelCost: number;
          readonly imageUrl: string;
          readonly outOfStock: boolean;
          readonly menuId: number;
        }>;
      };
};

export const PersonalizedUpsellsDocument = gql`
  query personalizedUpsells($restaurantId: String!, $costChannel: CostChannel) {
    personalizedUpsells(restaurantId: $restaurantId) {
      ... on PersonalizedUpsell {
        __typename
        customerId
        restaurantId
        products {
          id
          __typename
          name
          cost
          channelCost(costChannel: $costChannel)
          imageUrl
          outOfStock
          menuId
        }
      }
      ... on MenuNotFound {
        __typename
        errorMessage
      }
    }
  }
`;

export function usePersonalizedUpsellsQuery(
  options: Omit<Urql.UseQueryArgs<PersonalizedUpsellsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<PersonalizedUpsellsQuery, PersonalizedUpsellsQueryVariables>({
    query: PersonalizedUpsellsDocument,
    ...options,
  });
}
